import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { memo, useContext, useEffect, useState } from 'react';
import { EditInapectionContaxt } from './editInspectionProviderImports';

const setValue = (val, unit) => {
    if (val !== null && val !== undefined) {
        return (
            <>
                {val}
                <small>{unit}</small>
            </>
        );
    }
    return 'N/A';
};
export const EditInspectionRoadTest = memo(({ classes }) => {
    const { state } = useContext(EditInapectionContaxt);

    const [show, setShow] = useState({
        showAxle1: false,
        showAxle2: false,
        showAxle3: false,
        showAxle4: false
    });

    let handleAxle = () => {
        let showAxle1 = false;
        let showAxle2 = false;
        let showAxle3 = false;
        let showAxle4 = false;
        if (state.vehicleNoOfAxles) {
            switch (state.vehicleNoOfAxles) {
                case 1:
                    showAxle1 = true;
                    break;
                case 2:
                    showAxle1 = true;
                    showAxle2 = true;
                    break;
                case 3:
                    showAxle1 = true;
                    showAxle2 = true;
                    showAxle3 = true;
                    break;
                case 4:
                    showAxle1 = true;
                    showAxle2 = true;
                    showAxle3 = true;
                    showAxle4 = true;
                    break;

                default:
                    break;
            }
        } else {
            showAxle1 = true;
            showAxle2 = true;
            showAxle3 = true;
            showAxle4 = true;
        }

        setShow((st) => ({
            ...st,
            showAxle1: showAxle1,
            showAxle2: showAxle2,
            showAxle3: showAxle3,
            showAxle4: showAxle4
        }));
    };

    useEffect(() => {
        handleAxle();
    }, [state.vehicleNoOfAxles]);


    return (
        <Grid item container direction="row" xs={12} sm={12} md={6} lg={6}>
            <TableContainer component={Paper}>
                <div
                    style={{
                        border: '1px solid rgba(0,0,0,0.2)'
                    }}
                >
                    <h3 className={classes.title}>
                        Road Test &nbsp;<small>(Brake Temperature Assessment)</small>
                    </h3>
                </div>
                <Table aria-label="simple table" className={classes.paper}>
                    <TableHead>
                        <TableRow>
                            <TableCell width="5%">Side</TableCell>
                            {show.showAxle1 && <TableCell align="center" colSpan={2}>
                                Axle 1
                            </TableCell>}
                            {show.showAxle2 && <TableCell align="center" colSpan={2}>
                                Axle 2
                            </TableCell>}
                            {show.showAxle3 && <TableCell align="center" colSpan={2}>
                                Axle 3
                            </TableCell>}
                            {show.showAxle4 && <TableCell align="center" colSpan={2}>
                                Axle 4
                            </TableCell>}
                        </TableRow>
                        <TableRow>
                            <TableCell width="5%"></TableCell>
                            {show.showAxle1 && <TableCell align="Left">Before</TableCell>}
                            {show.showAxle1 && <TableCell align="Left">After</TableCell>}
                            {show.showAxle2 && <TableCell align="Left">Before</TableCell>}
                            {show.showAxle2 && <TableCell align="Left">After</TableCell>}
                            {show.showAxle3 && <TableCell align="Left">Before</TableCell>}
                            {show.showAxle3 && <TableCell align="Left">After</TableCell>}
                            {show.showAxle4 && <TableCell align="Left">Before</TableCell>}
                            {show.showAxle4 && <TableCell align="Left">After</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell component="th" width="5%">
                                <b>O/S</b>
                            </TableCell>
                            {show.showAxle1 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[0]?.osBeforeBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle1 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[0]?.osBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle2 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[1]?.osBeforeBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle2 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[1]?.osBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle3 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[2]?.osBeforeBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle3 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[2]?.osBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle4 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[3]?.osBeforeBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle4 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[3]?.osBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                        </TableRow>
                        <TableRow>
                            <TableCell component="th" width="5%">
                                <b>N/S</b>
                            </TableCell>

                            {show.showAxle1 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[0]?.nsBeforeBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle1 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[0]?.nsBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle2 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[1]?.nsBeforeBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle2 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[1]?.nsBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle3 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[2]?.nsBeforeBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle3 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[2]?.nsBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle4 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[3]?.nsBeforeBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                            {show.showAxle4 && <TableCell>
                                <Typography variant="button"> {setValue(state.tyreAxles[3]?.nsBrakeTemperatureAxle, '°C')}</Typography>
                            </TableCell>}
                        </TableRow>
                        <TableRow></TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
});
